import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {MODULE} from '../../../constants/Lookup';
import {submissionEnd} from '../CommonActions/commonActions';
const initialData = {
  isLoading: false,
  isWindowLoading: false,
  errorMsg: null,
  roleError: null,
  successMsg: null,
  addRoleStatus: null,
  addRoleData: {},
  dropDownData: {},
  windowDetails: [],
  allRoleNames: [],
  isNotesLoading: false,
  notesSuccessMsg: null,
  addSystemNotesStatus: null,
};

const slice = createSlice({
  name: 'addRole',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNotesStart: (state) => {
      state.isNotesLoading = true;
      state.errorMsg = null;
    },
    fetchWindowStart: (state) => {
      state.isWindowLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postRoleData: (state, action) => {
      state.addRoleStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postSystemNotesData: (state, action)=>{
      state.addSystemNotesStatus =action.payload.status;
      state.isNotesLoading=false;
      state.errorMsg =null;
      state.notesSuccessMsg=action.payload.response;
    },
    fetchAllRoleNames: (state, action) => {
      state.allRoleNames = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getAddRoleData: (state, action) => {
      state.addRoleData = action.payload;
      // state.isLoading = false;
      state.errorMsg = null;
      state.addRoleStatus = action.payload.status;
      state.successMsg = action.payload.message;
    },
    postWindow: (state, action) => {
      state.windowDetails = action.payload.response;
      state.isWindowLoading = false;
      state.errorMsg = null;
      // state.successMsg = action.payload.response;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : '';
      state.roleError = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.addRoleStatus = null;
      state.isLoading = false;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.roleError = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.addRoleStatus = null;
      state.windowDetails = [];
      state.addRoleData = {};
    },
    resetSystemNotesData: (state) => {
      state.isNotesLoading = false;
      state.addSystemNotesStatus = null;
      state.notesSuccessMsg = null;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  fetchSuccess,
  fetchError,
  fetchDropDownData,
  postWindow,
  fetchWindowStart,
  resetMessage,
  resetStatus,
  resetData,
  fetchAllRoleNames,
  postRoleData,
  getAddRoleData,
  fetchNotesStart,
  postSystemNotesData,
  resetSystemNotesData,
} = slice.actions;

export const postAddRoleData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`save/rolemgmtfunctionalites`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postRoleData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNotesStart());
    httpPost(`save/rolenotes`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAddRoleData = (Id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`get/rolemgmtfunctionalites/${Id}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getAddRoleData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [MODULE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postWindowDetails = (details) => {
  return (dispatch) => {
    dispatch(fetchWindowStart());
    httpPost('get/window', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postWindow(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getAllRoleNames = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet('get/all/role/rolename', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchAllRoleNames(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
